import { render, staticRenderFns } from "./TagPeople.vue?vue&type=template&id=34ac0dba&scoped=true&"
import script from "./TagPeople.vue?vue&type=script&lang=js&"
export * from "./TagPeople.vue?vue&type=script&lang=js&"
import style0 from "./TagPeople.vue?vue&type=style&index=0&id=34ac0dba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ac0dba",
  null
  
)

export default component.exports